/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RRmdCalculationIdRouteImport } from './routes/r.$rmdCalculationId'
import { Route as AppLearningRouteRouteImport } from './routes/_app/learning/route'
import { Route as AppBackofficeRouteRouteImport } from './routes/_app/backoffice/route'
import { Route as AuthLoginIndexRouteImport } from './routes/_auth/login/index'
import { Route as AppToolsIndexRouteImport } from './routes/_app/tools/index'
import { Route as AppSharefileMigrationIndexRouteImport } from './routes/_app/sharefile-migration/index'
import { Route as AppRecommendedFilesIndexRouteImport } from './routes/_app/recommended-files/index'
import { Route as AppProfileIndexRouteImport } from './routes/_app/profile/index'
import { Route as AppLearningIndexRouteImport } from './routes/_app/learning/index'
import { Route as AppIrsTablesIndexRouteImport } from './routes/_app/irs-tables/index'
import { Route as AppHomeIndexRouteImport } from './routes/_app/home/index'
import { Route as AppClientsIndexRouteImport } from './routes/_app/clients/index'
import { Route as AppBackofficeIndexRouteImport } from './routes/_app/backoffice/index'
import { Route as AppLearningBrowseRouteImport } from './routes/_app/learning/browse'
import { Route as AppAnnualReviewStartRouteImport } from './routes/_app/annual-review/start'
import { Route as AppToolsTaxFactoryIndexRouteImport } from './routes/_app/tools/tax-factory/index'
import { Route as AppToolsRmdCalculatorIndexRouteImport } from './routes/_app/tools/rmd-calculator/index'
import { Route as AppLearningAdminIndexRouteImport } from './routes/_app/learning/admin/index'
import { Route as AppLearningCourseSlugIndexRouteImport } from './routes/_app/learning/$courseSlug.index'
import { Route as AppClientsClientIdIndexRouteImport } from './routes/_app/clients/$clientId/index'
import { Route as AppBackofficeUsersIndexRouteImport } from './routes/_app/backoffice/users/index'
import { Route as AppBackofficeTermsIndexRouteImport } from './routes/_app/backoffice/terms/index'
import { Route as AppBackofficeLabelsIndexRouteImport } from './routes/_app/backoffice/labels/index'
import { Route as AppBackofficeJourneySchedulingIndexRouteImport } from './routes/_app/backoffice/journey-scheduling/index'
import { Route as AppBackofficeIntegrationsIndexRouteImport } from './routes/_app/backoffice/integrations/index'
import { Route as AppBackofficeForecastGroupNamesIndexRouteImport } from './routes/_app/backoffice/forecast-group-names/index'
import { Route as AppBackofficeBillingIndexRouteImport } from './routes/_app/backoffice/billing/index'
import { Route as AppBackofficeAnalyticsIndexRouteImport } from './routes/_app/backoffice/analytics/index'
import { Route as AppLearningAdminReportsRouteImport } from './routes/_app/learning/admin/reports'
import { Route as AppLearningAdminPropertiesRouteImport } from './routes/_app/learning/admin/properties'
import { Route as AppLearningAdminNewRouteImport } from './routes/_app/learning/admin/new'
import { Route as AppLearningAdminMediaRouteImport } from './routes/_app/learning/admin/media'
import { Route as AppLearningAdminVersionIdIndexRouteImport } from './routes/_app/learning/admin/$versionId.index'
import { Route as AppBackofficeJourneySchedulingMeetingTypesIndexRouteImport } from './routes/_app/backoffice/journey-scheduling/meeting-types/index'
import { Route as AppBackofficeIntegrationsZoomIndexRouteImport } from './routes/_app/backoffice/integrations/zoom/index'
import { Route as AppBackofficeIntegrationsStripeIndexRouteImport } from './routes/_app/backoffice/integrations/stripe/index'
import { Route as AppBackofficeIntegrationsSlackIndexRouteImport } from './routes/_app/backoffice/integrations/slack/index'
import { Route as AppBackofficeIntegrationsRulesEngineIndexRouteImport } from './routes/_app/backoffice/integrations/rules-engine/index'
import { Route as AppBackofficeIntegrationsRothRadarIndexRouteImport } from './routes/_app/backoffice/integrations/roth-radar/index'
import { Route as AppBackofficeIntegrationsPlaidIndexRouteImport } from './routes/_app/backoffice/integrations/plaid/index'
import { Route as AppBackofficeIntegrationsMuxIndexRouteImport } from './routes/_app/backoffice/integrations/mux.index'
import { Route as AppBackofficeIntegrationsMeetingTranscriptsIndexRouteImport } from './routes/_app/backoffice/integrations/meeting-transcripts/index'
import { Route as AppBackofficeIntegrationsHubspotIndexRouteImport } from './routes/_app/backoffice/integrations/hubspot/index'
import { Route as AppBackofficeIntegrationsGoogleDriveIndexRouteImport } from './routes/_app/backoffice/integrations/google-drive/index'
import { Route as AppBackofficeIntegrationsFrontIndexRouteImport } from './routes/_app/backoffice/integrations/front/index'
import { Route as AppBackofficeAnalyticsForecastsIndexRouteImport } from './routes/_app/backoffice/analytics/forecasts/index'
import { Route as AppBackofficeAdminParityIndexRouteImport } from './routes/_app/backoffice/admin/parity/index'
import { Route as AppLearningAdminVersionIdPreviewRouteImport } from './routes/_app/learning/admin/$versionId.preview'
import { Route as AppLearningAdminVersionIdAssignRouteImport } from './routes/_app/learning/admin/$versionId.assign'
import { Route as AppLearningCourseSlugLessonLessonIdRouteImport } from './routes/_app/learning/$courseSlug.lesson.$lessonId'
import { Route as AppClientsClientIdPortalImpersonateRouteImport } from './routes/_app/clients/$clientId/portal/impersonate'
import { Route as AppBackofficeAnalyticsUsersUserIdIndexRouteImport } from './routes/_app/backoffice/analytics/users/$userId/index'
import { Route as AppBackofficeAdminParityForecastIdIndexRouteImport } from './routes/_app/backoffice/admin/parity/$forecastId/index'

const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const RRmdCalculationIdRoute = RRmdCalculationIdRouteImport.update({
  id: '/r/$rmdCalculationId',
  path: '/r/$rmdCalculationId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppLearningRouteRoute = AppLearningRouteRouteImport.update({
  id: '/learning',
  path: '/learning',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBackofficeRouteRoute = AppBackofficeRouteRouteImport.update({
  id: '/backoffice',
  path: '/backoffice',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthLoginIndexRoute = AuthLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AppToolsIndexRoute = AppToolsIndexRouteImport.update({
  id: '/tools/',
  path: '/tools/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSharefileMigrationIndexRoute =
  AppSharefileMigrationIndexRouteImport.update({
    id: '/sharefile-migration/',
    path: '/sharefile-migration/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppRecommendedFilesIndexRoute =
  AppRecommendedFilesIndexRouteImport.update({
    id: '/recommended-files/',
    path: '/recommended-files/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppProfileIndexRoute = AppProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppLearningIndexRoute = AppLearningIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLearningRouteRoute,
} as any)
const AppIrsTablesIndexRoute = AppIrsTablesIndexRouteImport.update({
  id: '/irs-tables/',
  path: '/irs-tables/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppHomeIndexRoute = AppHomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBackofficeIndexRoute = AppBackofficeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppBackofficeRouteRoute,
} as any)
const AppLearningBrowseRoute = AppLearningBrowseRouteImport.update({
  id: '/browse',
  path: '/browse',
  getParentRoute: () => AppLearningRouteRoute,
} as any)
const AppAnnualReviewStartRoute = AppAnnualReviewStartRouteImport.update({
  id: '/annual-review/start',
  path: '/annual-review/start',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppToolsTaxFactoryIndexRoute = AppToolsTaxFactoryIndexRouteImport.update({
  id: '/tools/tax-factory/',
  path: '/tools/tax-factory/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppToolsRmdCalculatorIndexRoute =
  AppToolsRmdCalculatorIndexRouteImport.update({
    id: '/tools/rmd-calculator/',
    path: '/tools/rmd-calculator/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppLearningAdminIndexRoute = AppLearningAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => AppLearningRouteRoute,
} as any)
const AppLearningCourseSlugIndexRoute =
  AppLearningCourseSlugIndexRouteImport.update({
    id: '/$courseSlug/',
    path: '/$courseSlug/',
    getParentRoute: () => AppLearningRouteRoute,
  } as any)
const AppClientsClientIdIndexRoute = AppClientsClientIdIndexRouteImport.update({
  id: '/clients/$clientId/',
  path: '/clients/$clientId/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBackofficeUsersIndexRoute = AppBackofficeUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppBackofficeRouteRoute,
} as any)
const AppBackofficeTermsIndexRoute = AppBackofficeTermsIndexRouteImport.update({
  id: '/terms/',
  path: '/terms/',
  getParentRoute: () => AppBackofficeRouteRoute,
} as any)
const AppBackofficeLabelsIndexRoute =
  AppBackofficeLabelsIndexRouteImport.update({
    id: '/labels/',
    path: '/labels/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppBackofficeJourneySchedulingIndexRoute =
  AppBackofficeJourneySchedulingIndexRouteImport.update({
    id: '/journey-scheduling/',
    path: '/journey-scheduling/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppBackofficeIntegrationsIndexRoute =
  AppBackofficeIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppBackofficeForecastGroupNamesIndexRoute =
  AppBackofficeForecastGroupNamesIndexRouteImport.update({
    id: '/forecast-group-names/',
    path: '/forecast-group-names/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppBackofficeBillingIndexRoute =
  AppBackofficeBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppBackofficeAnalyticsIndexRoute =
  AppBackofficeAnalyticsIndexRouteImport.update({
    id: '/analytics/',
    path: '/analytics/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppLearningAdminReportsRoute = AppLearningAdminReportsRouteImport.update({
  id: '/admin/reports',
  path: '/admin/reports',
  getParentRoute: () => AppLearningRouteRoute,
} as any)
const AppLearningAdminPropertiesRoute =
  AppLearningAdminPropertiesRouteImport.update({
    id: '/admin/properties',
    path: '/admin/properties',
    getParentRoute: () => AppLearningRouteRoute,
  } as any)
const AppLearningAdminNewRoute = AppLearningAdminNewRouteImport.update({
  id: '/admin/new',
  path: '/admin/new',
  getParentRoute: () => AppLearningRouteRoute,
} as any)
const AppLearningAdminMediaRoute = AppLearningAdminMediaRouteImport.update({
  id: '/admin/media',
  path: '/admin/media',
  getParentRoute: () => AppLearningRouteRoute,
} as any)
const AppLearningAdminVersionIdIndexRoute =
  AppLearningAdminVersionIdIndexRouteImport.update({
    id: '/admin/$versionId/',
    path: '/admin/$versionId/',
    getParentRoute: () => AppLearningRouteRoute,
  } as any)
const AppBackofficeJourneySchedulingMeetingTypesIndexRoute =
  AppBackofficeJourneySchedulingMeetingTypesIndexRouteImport.update({
    id: '/journey-scheduling/meeting-types/',
    path: '/journey-scheduling/meeting-types/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppBackofficeIntegrationsZoomIndexRoute =
  AppBackofficeIntegrationsZoomIndexRouteImport.update({
    id: '/integrations/zoom/',
    path: '/integrations/zoom/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppBackofficeIntegrationsStripeIndexRoute =
  AppBackofficeIntegrationsStripeIndexRouteImport.update({
    id: '/integrations/stripe/',
    path: '/integrations/stripe/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppBackofficeIntegrationsSlackIndexRoute =
  AppBackofficeIntegrationsSlackIndexRouteImport.update({
    id: '/integrations/slack/',
    path: '/integrations/slack/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppBackofficeIntegrationsRulesEngineIndexRoute =
  AppBackofficeIntegrationsRulesEngineIndexRouteImport.update({
    id: '/integrations/rules-engine/',
    path: '/integrations/rules-engine/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppBackofficeIntegrationsRothRadarIndexRoute =
  AppBackofficeIntegrationsRothRadarIndexRouteImport.update({
    id: '/integrations/roth-radar/',
    path: '/integrations/roth-radar/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppBackofficeIntegrationsPlaidIndexRoute =
  AppBackofficeIntegrationsPlaidIndexRouteImport.update({
    id: '/integrations/plaid/',
    path: '/integrations/plaid/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppBackofficeIntegrationsMuxIndexRoute =
  AppBackofficeIntegrationsMuxIndexRouteImport.update({
    id: '/integrations/mux/',
    path: '/integrations/mux/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppBackofficeIntegrationsMeetingTranscriptsIndexRoute =
  AppBackofficeIntegrationsMeetingTranscriptsIndexRouteImport.update({
    id: '/integrations/meeting-transcripts/',
    path: '/integrations/meeting-transcripts/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppBackofficeIntegrationsHubspotIndexRoute =
  AppBackofficeIntegrationsHubspotIndexRouteImport.update({
    id: '/integrations/hubspot/',
    path: '/integrations/hubspot/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppBackofficeIntegrationsGoogleDriveIndexRoute =
  AppBackofficeIntegrationsGoogleDriveIndexRouteImport.update({
    id: '/integrations/google-drive/',
    path: '/integrations/google-drive/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppBackofficeIntegrationsFrontIndexRoute =
  AppBackofficeIntegrationsFrontIndexRouteImport.update({
    id: '/integrations/front/',
    path: '/integrations/front/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppBackofficeAnalyticsForecastsIndexRoute =
  AppBackofficeAnalyticsForecastsIndexRouteImport.update({
    id: '/analytics/forecasts/',
    path: '/analytics/forecasts/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppBackofficeAdminParityIndexRoute =
  AppBackofficeAdminParityIndexRouteImport.update({
    id: '/admin/parity/',
    path: '/admin/parity/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppLearningAdminVersionIdPreviewRoute =
  AppLearningAdminVersionIdPreviewRouteImport.update({
    id: '/admin/$versionId/preview',
    path: '/admin/$versionId/preview',
    getParentRoute: () => AppLearningRouteRoute,
  } as any)
const AppLearningAdminVersionIdAssignRoute =
  AppLearningAdminVersionIdAssignRouteImport.update({
    id: '/admin/$versionId/assign',
    path: '/admin/$versionId/assign',
    getParentRoute: () => AppLearningRouteRoute,
  } as any)
const AppLearningCourseSlugLessonLessonIdRoute =
  AppLearningCourseSlugLessonLessonIdRouteImport.update({
    id: '/$courseSlug/lesson/$lessonId',
    path: '/$courseSlug/lesson/$lessonId',
    getParentRoute: () => AppLearningRouteRoute,
  } as any)
const AppClientsClientIdPortalImpersonateRoute =
  AppClientsClientIdPortalImpersonateRouteImport.update({
    id: '/clients/$clientId/portal/impersonate',
    path: '/clients/$clientId/portal/impersonate',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppBackofficeAnalyticsUsersUserIdIndexRoute =
  AppBackofficeAnalyticsUsersUserIdIndexRouteImport.update({
    id: '/analytics/users/$userId/',
    path: '/analytics/users/$userId/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)
const AppBackofficeAdminParityForecastIdIndexRoute =
  AppBackofficeAdminParityForecastIdIndexRouteImport.update({
    id: '/admin/parity/$forecastId/',
    path: '/admin/parity/$forecastId/',
    getParentRoute: () => AppBackofficeRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/backoffice': typeof AppBackofficeRouteRouteWithChildren
  '/learning': typeof AppLearningRouteRouteWithChildren
  '/r/$rmdCalculationId': typeof RRmdCalculationIdRoute
  '/annual-review/start': typeof AppAnnualReviewStartRoute
  '/learning/browse': typeof AppLearningBrowseRoute
  '/backoffice/': typeof AppBackofficeIndexRoute
  '/clients': typeof AppClientsIndexRoute
  '/home': typeof AppHomeIndexRoute
  '/irs-tables': typeof AppIrsTablesIndexRoute
  '/learning/': typeof AppLearningIndexRoute
  '/profile': typeof AppProfileIndexRoute
  '/recommended-files': typeof AppRecommendedFilesIndexRoute
  '/sharefile-migration': typeof AppSharefileMigrationIndexRoute
  '/tools': typeof AppToolsIndexRoute
  '/login': typeof AuthLoginIndexRoute
  '/learning/admin/media': typeof AppLearningAdminMediaRoute
  '/learning/admin/new': typeof AppLearningAdminNewRoute
  '/learning/admin/properties': typeof AppLearningAdminPropertiesRoute
  '/learning/admin/reports': typeof AppLearningAdminReportsRoute
  '/backoffice/analytics': typeof AppBackofficeAnalyticsIndexRoute
  '/backoffice/billing': typeof AppBackofficeBillingIndexRoute
  '/backoffice/forecast-group-names': typeof AppBackofficeForecastGroupNamesIndexRoute
  '/backoffice/integrations': typeof AppBackofficeIntegrationsIndexRoute
  '/backoffice/journey-scheduling': typeof AppBackofficeJourneySchedulingIndexRoute
  '/backoffice/labels': typeof AppBackofficeLabelsIndexRoute
  '/backoffice/terms': typeof AppBackofficeTermsIndexRoute
  '/backoffice/users': typeof AppBackofficeUsersIndexRoute
  '/clients/$clientId': typeof AppClientsClientIdIndexRoute
  '/learning/$courseSlug': typeof AppLearningCourseSlugIndexRoute
  '/learning/admin': typeof AppLearningAdminIndexRoute
  '/tools/rmd-calculator': typeof AppToolsRmdCalculatorIndexRoute
  '/tools/tax-factory': typeof AppToolsTaxFactoryIndexRoute
  '/clients/$clientId/portal/impersonate': typeof AppClientsClientIdPortalImpersonateRoute
  '/learning/$courseSlug/lesson/$lessonId': typeof AppLearningCourseSlugLessonLessonIdRoute
  '/learning/admin/$versionId/assign': typeof AppLearningAdminVersionIdAssignRoute
  '/learning/admin/$versionId/preview': typeof AppLearningAdminVersionIdPreviewRoute
  '/backoffice/admin/parity': typeof AppBackofficeAdminParityIndexRoute
  '/backoffice/analytics/forecasts': typeof AppBackofficeAnalyticsForecastsIndexRoute
  '/backoffice/integrations/front': typeof AppBackofficeIntegrationsFrontIndexRoute
  '/backoffice/integrations/google-drive': typeof AppBackofficeIntegrationsGoogleDriveIndexRoute
  '/backoffice/integrations/hubspot': typeof AppBackofficeIntegrationsHubspotIndexRoute
  '/backoffice/integrations/meeting-transcripts': typeof AppBackofficeIntegrationsMeetingTranscriptsIndexRoute
  '/backoffice/integrations/mux': typeof AppBackofficeIntegrationsMuxIndexRoute
  '/backoffice/integrations/plaid': typeof AppBackofficeIntegrationsPlaidIndexRoute
  '/backoffice/integrations/roth-radar': typeof AppBackofficeIntegrationsRothRadarIndexRoute
  '/backoffice/integrations/rules-engine': typeof AppBackofficeIntegrationsRulesEngineIndexRoute
  '/backoffice/integrations/slack': typeof AppBackofficeIntegrationsSlackIndexRoute
  '/backoffice/integrations/stripe': typeof AppBackofficeIntegrationsStripeIndexRoute
  '/backoffice/integrations/zoom': typeof AppBackofficeIntegrationsZoomIndexRoute
  '/backoffice/journey-scheduling/meeting-types': typeof AppBackofficeJourneySchedulingMeetingTypesIndexRoute
  '/learning/admin/$versionId': typeof AppLearningAdminVersionIdIndexRoute
  '/backoffice/admin/parity/$forecastId': typeof AppBackofficeAdminParityForecastIdIndexRoute
  '/backoffice/analytics/users/$userId': typeof AppBackofficeAnalyticsUsersUserIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/r/$rmdCalculationId': typeof RRmdCalculationIdRoute
  '/annual-review/start': typeof AppAnnualReviewStartRoute
  '/learning/browse': typeof AppLearningBrowseRoute
  '/backoffice': typeof AppBackofficeIndexRoute
  '/clients': typeof AppClientsIndexRoute
  '/home': typeof AppHomeIndexRoute
  '/irs-tables': typeof AppIrsTablesIndexRoute
  '/learning': typeof AppLearningIndexRoute
  '/profile': typeof AppProfileIndexRoute
  '/recommended-files': typeof AppRecommendedFilesIndexRoute
  '/sharefile-migration': typeof AppSharefileMigrationIndexRoute
  '/tools': typeof AppToolsIndexRoute
  '/login': typeof AuthLoginIndexRoute
  '/learning/admin/media': typeof AppLearningAdminMediaRoute
  '/learning/admin/new': typeof AppLearningAdminNewRoute
  '/learning/admin/properties': typeof AppLearningAdminPropertiesRoute
  '/learning/admin/reports': typeof AppLearningAdminReportsRoute
  '/backoffice/analytics': typeof AppBackofficeAnalyticsIndexRoute
  '/backoffice/billing': typeof AppBackofficeBillingIndexRoute
  '/backoffice/forecast-group-names': typeof AppBackofficeForecastGroupNamesIndexRoute
  '/backoffice/integrations': typeof AppBackofficeIntegrationsIndexRoute
  '/backoffice/journey-scheduling': typeof AppBackofficeJourneySchedulingIndexRoute
  '/backoffice/labels': typeof AppBackofficeLabelsIndexRoute
  '/backoffice/terms': typeof AppBackofficeTermsIndexRoute
  '/backoffice/users': typeof AppBackofficeUsersIndexRoute
  '/clients/$clientId': typeof AppClientsClientIdIndexRoute
  '/learning/$courseSlug': typeof AppLearningCourseSlugIndexRoute
  '/learning/admin': typeof AppLearningAdminIndexRoute
  '/tools/rmd-calculator': typeof AppToolsRmdCalculatorIndexRoute
  '/tools/tax-factory': typeof AppToolsTaxFactoryIndexRoute
  '/clients/$clientId/portal/impersonate': typeof AppClientsClientIdPortalImpersonateRoute
  '/learning/$courseSlug/lesson/$lessonId': typeof AppLearningCourseSlugLessonLessonIdRoute
  '/learning/admin/$versionId/assign': typeof AppLearningAdminVersionIdAssignRoute
  '/learning/admin/$versionId/preview': typeof AppLearningAdminVersionIdPreviewRoute
  '/backoffice/admin/parity': typeof AppBackofficeAdminParityIndexRoute
  '/backoffice/analytics/forecasts': typeof AppBackofficeAnalyticsForecastsIndexRoute
  '/backoffice/integrations/front': typeof AppBackofficeIntegrationsFrontIndexRoute
  '/backoffice/integrations/google-drive': typeof AppBackofficeIntegrationsGoogleDriveIndexRoute
  '/backoffice/integrations/hubspot': typeof AppBackofficeIntegrationsHubspotIndexRoute
  '/backoffice/integrations/meeting-transcripts': typeof AppBackofficeIntegrationsMeetingTranscriptsIndexRoute
  '/backoffice/integrations/mux': typeof AppBackofficeIntegrationsMuxIndexRoute
  '/backoffice/integrations/plaid': typeof AppBackofficeIntegrationsPlaidIndexRoute
  '/backoffice/integrations/roth-radar': typeof AppBackofficeIntegrationsRothRadarIndexRoute
  '/backoffice/integrations/rules-engine': typeof AppBackofficeIntegrationsRulesEngineIndexRoute
  '/backoffice/integrations/slack': typeof AppBackofficeIntegrationsSlackIndexRoute
  '/backoffice/integrations/stripe': typeof AppBackofficeIntegrationsStripeIndexRoute
  '/backoffice/integrations/zoom': typeof AppBackofficeIntegrationsZoomIndexRoute
  '/backoffice/journey-scheduling/meeting-types': typeof AppBackofficeJourneySchedulingMeetingTypesIndexRoute
  '/learning/admin/$versionId': typeof AppLearningAdminVersionIdIndexRoute
  '/backoffice/admin/parity/$forecastId': typeof AppBackofficeAdminParityForecastIdIndexRoute
  '/backoffice/analytics/users/$userId': typeof AppBackofficeAnalyticsUsersUserIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteRouteWithChildren
  '/_auth': typeof AuthRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/_app/backoffice': typeof AppBackofficeRouteRouteWithChildren
  '/_app/learning': typeof AppLearningRouteRouteWithChildren
  '/r/$rmdCalculationId': typeof RRmdCalculationIdRoute
  '/_app/annual-review/start': typeof AppAnnualReviewStartRoute
  '/_app/learning/browse': typeof AppLearningBrowseRoute
  '/_app/backoffice/': typeof AppBackofficeIndexRoute
  '/_app/clients/': typeof AppClientsIndexRoute
  '/_app/home/': typeof AppHomeIndexRoute
  '/_app/irs-tables/': typeof AppIrsTablesIndexRoute
  '/_app/learning/': typeof AppLearningIndexRoute
  '/_app/profile/': typeof AppProfileIndexRoute
  '/_app/recommended-files/': typeof AppRecommendedFilesIndexRoute
  '/_app/sharefile-migration/': typeof AppSharefileMigrationIndexRoute
  '/_app/tools/': typeof AppToolsIndexRoute
  '/_auth/login/': typeof AuthLoginIndexRoute
  '/_app/learning/admin/media': typeof AppLearningAdminMediaRoute
  '/_app/learning/admin/new': typeof AppLearningAdminNewRoute
  '/_app/learning/admin/properties': typeof AppLearningAdminPropertiesRoute
  '/_app/learning/admin/reports': typeof AppLearningAdminReportsRoute
  '/_app/backoffice/analytics/': typeof AppBackofficeAnalyticsIndexRoute
  '/_app/backoffice/billing/': typeof AppBackofficeBillingIndexRoute
  '/_app/backoffice/forecast-group-names/': typeof AppBackofficeForecastGroupNamesIndexRoute
  '/_app/backoffice/integrations/': typeof AppBackofficeIntegrationsIndexRoute
  '/_app/backoffice/journey-scheduling/': typeof AppBackofficeJourneySchedulingIndexRoute
  '/_app/backoffice/labels/': typeof AppBackofficeLabelsIndexRoute
  '/_app/backoffice/terms/': typeof AppBackofficeTermsIndexRoute
  '/_app/backoffice/users/': typeof AppBackofficeUsersIndexRoute
  '/_app/clients/$clientId/': typeof AppClientsClientIdIndexRoute
  '/_app/learning/$courseSlug/': typeof AppLearningCourseSlugIndexRoute
  '/_app/learning/admin/': typeof AppLearningAdminIndexRoute
  '/_app/tools/rmd-calculator/': typeof AppToolsRmdCalculatorIndexRoute
  '/_app/tools/tax-factory/': typeof AppToolsTaxFactoryIndexRoute
  '/_app/clients/$clientId/portal/impersonate': typeof AppClientsClientIdPortalImpersonateRoute
  '/_app/learning/$courseSlug/lesson/$lessonId': typeof AppLearningCourseSlugLessonLessonIdRoute
  '/_app/learning/admin/$versionId/assign': typeof AppLearningAdminVersionIdAssignRoute
  '/_app/learning/admin/$versionId/preview': typeof AppLearningAdminVersionIdPreviewRoute
  '/_app/backoffice/admin/parity/': typeof AppBackofficeAdminParityIndexRoute
  '/_app/backoffice/analytics/forecasts/': typeof AppBackofficeAnalyticsForecastsIndexRoute
  '/_app/backoffice/integrations/front/': typeof AppBackofficeIntegrationsFrontIndexRoute
  '/_app/backoffice/integrations/google-drive/': typeof AppBackofficeIntegrationsGoogleDriveIndexRoute
  '/_app/backoffice/integrations/hubspot/': typeof AppBackofficeIntegrationsHubspotIndexRoute
  '/_app/backoffice/integrations/meeting-transcripts/': typeof AppBackofficeIntegrationsMeetingTranscriptsIndexRoute
  '/_app/backoffice/integrations/mux/': typeof AppBackofficeIntegrationsMuxIndexRoute
  '/_app/backoffice/integrations/plaid/': typeof AppBackofficeIntegrationsPlaidIndexRoute
  '/_app/backoffice/integrations/roth-radar/': typeof AppBackofficeIntegrationsRothRadarIndexRoute
  '/_app/backoffice/integrations/rules-engine/': typeof AppBackofficeIntegrationsRulesEngineIndexRoute
  '/_app/backoffice/integrations/slack/': typeof AppBackofficeIntegrationsSlackIndexRoute
  '/_app/backoffice/integrations/stripe/': typeof AppBackofficeIntegrationsStripeIndexRoute
  '/_app/backoffice/integrations/zoom/': typeof AppBackofficeIntegrationsZoomIndexRoute
  '/_app/backoffice/journey-scheduling/meeting-types/': typeof AppBackofficeJourneySchedulingMeetingTypesIndexRoute
  '/_app/learning/admin/$versionId/': typeof AppLearningAdminVersionIdIndexRoute
  '/_app/backoffice/admin/parity/$forecastId/': typeof AppBackofficeAdminParityForecastIdIndexRoute
  '/_app/backoffice/analytics/users/$userId/': typeof AppBackofficeAnalyticsUsersUserIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/backoffice'
    | '/learning'
    | '/r/$rmdCalculationId'
    | '/annual-review/start'
    | '/learning/browse'
    | '/backoffice/'
    | '/clients'
    | '/home'
    | '/irs-tables'
    | '/learning/'
    | '/profile'
    | '/recommended-files'
    | '/sharefile-migration'
    | '/tools'
    | '/login'
    | '/learning/admin/media'
    | '/learning/admin/new'
    | '/learning/admin/properties'
    | '/learning/admin/reports'
    | '/backoffice/analytics'
    | '/backoffice/billing'
    | '/backoffice/forecast-group-names'
    | '/backoffice/integrations'
    | '/backoffice/journey-scheduling'
    | '/backoffice/labels'
    | '/backoffice/terms'
    | '/backoffice/users'
    | '/clients/$clientId'
    | '/learning/$courseSlug'
    | '/learning/admin'
    | '/tools/rmd-calculator'
    | '/tools/tax-factory'
    | '/clients/$clientId/portal/impersonate'
    | '/learning/$courseSlug/lesson/$lessonId'
    | '/learning/admin/$versionId/assign'
    | '/learning/admin/$versionId/preview'
    | '/backoffice/admin/parity'
    | '/backoffice/analytics/forecasts'
    | '/backoffice/integrations/front'
    | '/backoffice/integrations/google-drive'
    | '/backoffice/integrations/hubspot'
    | '/backoffice/integrations/meeting-transcripts'
    | '/backoffice/integrations/mux'
    | '/backoffice/integrations/plaid'
    | '/backoffice/integrations/roth-radar'
    | '/backoffice/integrations/rules-engine'
    | '/backoffice/integrations/slack'
    | '/backoffice/integrations/stripe'
    | '/backoffice/integrations/zoom'
    | '/backoffice/journey-scheduling/meeting-types'
    | '/learning/admin/$versionId'
    | '/backoffice/admin/parity/$forecastId'
    | '/backoffice/analytics/users/$userId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/r/$rmdCalculationId'
    | '/annual-review/start'
    | '/learning/browse'
    | '/backoffice'
    | '/clients'
    | '/home'
    | '/irs-tables'
    | '/learning'
    | '/profile'
    | '/recommended-files'
    | '/sharefile-migration'
    | '/tools'
    | '/login'
    | '/learning/admin/media'
    | '/learning/admin/new'
    | '/learning/admin/properties'
    | '/learning/admin/reports'
    | '/backoffice/analytics'
    | '/backoffice/billing'
    | '/backoffice/forecast-group-names'
    | '/backoffice/integrations'
    | '/backoffice/journey-scheduling'
    | '/backoffice/labels'
    | '/backoffice/terms'
    | '/backoffice/users'
    | '/clients/$clientId'
    | '/learning/$courseSlug'
    | '/learning/admin'
    | '/tools/rmd-calculator'
    | '/tools/tax-factory'
    | '/clients/$clientId/portal/impersonate'
    | '/learning/$courseSlug/lesson/$lessonId'
    | '/learning/admin/$versionId/assign'
    | '/learning/admin/$versionId/preview'
    | '/backoffice/admin/parity'
    | '/backoffice/analytics/forecasts'
    | '/backoffice/integrations/front'
    | '/backoffice/integrations/google-drive'
    | '/backoffice/integrations/hubspot'
    | '/backoffice/integrations/meeting-transcripts'
    | '/backoffice/integrations/mux'
    | '/backoffice/integrations/plaid'
    | '/backoffice/integrations/roth-radar'
    | '/backoffice/integrations/rules-engine'
    | '/backoffice/integrations/slack'
    | '/backoffice/integrations/stripe'
    | '/backoffice/integrations/zoom'
    | '/backoffice/journey-scheduling/meeting-types'
    | '/learning/admin/$versionId'
    | '/backoffice/admin/parity/$forecastId'
    | '/backoffice/analytics/users/$userId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/$'
    | '/_app/backoffice'
    | '/_app/learning'
    | '/r/$rmdCalculationId'
    | '/_app/annual-review/start'
    | '/_app/learning/browse'
    | '/_app/backoffice/'
    | '/_app/clients/'
    | '/_app/home/'
    | '/_app/irs-tables/'
    | '/_app/learning/'
    | '/_app/profile/'
    | '/_app/recommended-files/'
    | '/_app/sharefile-migration/'
    | '/_app/tools/'
    | '/_auth/login/'
    | '/_app/learning/admin/media'
    | '/_app/learning/admin/new'
    | '/_app/learning/admin/properties'
    | '/_app/learning/admin/reports'
    | '/_app/backoffice/analytics/'
    | '/_app/backoffice/billing/'
    | '/_app/backoffice/forecast-group-names/'
    | '/_app/backoffice/integrations/'
    | '/_app/backoffice/journey-scheduling/'
    | '/_app/backoffice/labels/'
    | '/_app/backoffice/terms/'
    | '/_app/backoffice/users/'
    | '/_app/clients/$clientId/'
    | '/_app/learning/$courseSlug/'
    | '/_app/learning/admin/'
    | '/_app/tools/rmd-calculator/'
    | '/_app/tools/tax-factory/'
    | '/_app/clients/$clientId/portal/impersonate'
    | '/_app/learning/$courseSlug/lesson/$lessonId'
    | '/_app/learning/admin/$versionId/assign'
    | '/_app/learning/admin/$versionId/preview'
    | '/_app/backoffice/admin/parity/'
    | '/_app/backoffice/analytics/forecasts/'
    | '/_app/backoffice/integrations/front/'
    | '/_app/backoffice/integrations/google-drive/'
    | '/_app/backoffice/integrations/hubspot/'
    | '/_app/backoffice/integrations/meeting-transcripts/'
    | '/_app/backoffice/integrations/mux/'
    | '/_app/backoffice/integrations/plaid/'
    | '/_app/backoffice/integrations/roth-radar/'
    | '/_app/backoffice/integrations/rules-engine/'
    | '/_app/backoffice/integrations/slack/'
    | '/_app/backoffice/integrations/stripe/'
    | '/_app/backoffice/integrations/zoom/'
    | '/_app/backoffice/journey-scheduling/meeting-types/'
    | '/_app/learning/admin/$versionId/'
    | '/_app/backoffice/admin/parity/$forecastId/'
    | '/_app/backoffice/analytics/users/$userId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  SplatRoute: typeof SplatRoute
  RRmdCalculationIdRoute: typeof RRmdCalculationIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$rmdCalculationId': {
      id: '/r/$rmdCalculationId'
      path: '/r/$rmdCalculationId'
      fullPath: '/r/$rmdCalculationId'
      preLoaderRoute: typeof RRmdCalculationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/learning': {
      id: '/_app/learning'
      path: '/learning'
      fullPath: '/learning'
      preLoaderRoute: typeof AppLearningRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/backoffice': {
      id: '/_app/backoffice'
      path: '/backoffice'
      fullPath: '/backoffice'
      preLoaderRoute: typeof AppBackofficeRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_auth/login/': {
      id: '/_auth/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_app/tools/': {
      id: '/_app/tools/'
      path: '/tools'
      fullPath: '/tools'
      preLoaderRoute: typeof AppToolsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/sharefile-migration/': {
      id: '/_app/sharefile-migration/'
      path: '/sharefile-migration'
      fullPath: '/sharefile-migration'
      preLoaderRoute: typeof AppSharefileMigrationIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/recommended-files/': {
      id: '/_app/recommended-files/'
      path: '/recommended-files'
      fullPath: '/recommended-files'
      preLoaderRoute: typeof AppRecommendedFilesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/profile/': {
      id: '/_app/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/learning/': {
      id: '/_app/learning/'
      path: '/'
      fullPath: '/learning/'
      preLoaderRoute: typeof AppLearningIndexRouteImport
      parentRoute: typeof AppLearningRouteRoute
    }
    '/_app/irs-tables/': {
      id: '/_app/irs-tables/'
      path: '/irs-tables'
      fullPath: '/irs-tables'
      preLoaderRoute: typeof AppIrsTablesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/home/': {
      id: '/_app/home/'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppHomeIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/clients/': {
      id: '/_app/clients/'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AppClientsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/backoffice/': {
      id: '/_app/backoffice/'
      path: '/'
      fullPath: '/backoffice/'
      preLoaderRoute: typeof AppBackofficeIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/learning/browse': {
      id: '/_app/learning/browse'
      path: '/browse'
      fullPath: '/learning/browse'
      preLoaderRoute: typeof AppLearningBrowseRouteImport
      parentRoute: typeof AppLearningRouteRoute
    }
    '/_app/annual-review/start': {
      id: '/_app/annual-review/start'
      path: '/annual-review/start'
      fullPath: '/annual-review/start'
      preLoaderRoute: typeof AppAnnualReviewStartRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/tools/tax-factory/': {
      id: '/_app/tools/tax-factory/'
      path: '/tools/tax-factory'
      fullPath: '/tools/tax-factory'
      preLoaderRoute: typeof AppToolsTaxFactoryIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/tools/rmd-calculator/': {
      id: '/_app/tools/rmd-calculator/'
      path: '/tools/rmd-calculator'
      fullPath: '/tools/rmd-calculator'
      preLoaderRoute: typeof AppToolsRmdCalculatorIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/learning/admin/': {
      id: '/_app/learning/admin/'
      path: '/admin'
      fullPath: '/learning/admin'
      preLoaderRoute: typeof AppLearningAdminIndexRouteImport
      parentRoute: typeof AppLearningRouteRoute
    }
    '/_app/learning/$courseSlug/': {
      id: '/_app/learning/$courseSlug/'
      path: '/$courseSlug'
      fullPath: '/learning/$courseSlug'
      preLoaderRoute: typeof AppLearningCourseSlugIndexRouteImport
      parentRoute: typeof AppLearningRouteRoute
    }
    '/_app/clients/$clientId/': {
      id: '/_app/clients/$clientId/'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof AppClientsClientIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/backoffice/users/': {
      id: '/_app/backoffice/users/'
      path: '/users'
      fullPath: '/backoffice/users'
      preLoaderRoute: typeof AppBackofficeUsersIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/terms/': {
      id: '/_app/backoffice/terms/'
      path: '/terms'
      fullPath: '/backoffice/terms'
      preLoaderRoute: typeof AppBackofficeTermsIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/labels/': {
      id: '/_app/backoffice/labels/'
      path: '/labels'
      fullPath: '/backoffice/labels'
      preLoaderRoute: typeof AppBackofficeLabelsIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/journey-scheduling/': {
      id: '/_app/backoffice/journey-scheduling/'
      path: '/journey-scheduling'
      fullPath: '/backoffice/journey-scheduling'
      preLoaderRoute: typeof AppBackofficeJourneySchedulingIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/integrations/': {
      id: '/_app/backoffice/integrations/'
      path: '/integrations'
      fullPath: '/backoffice/integrations'
      preLoaderRoute: typeof AppBackofficeIntegrationsIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/forecast-group-names/': {
      id: '/_app/backoffice/forecast-group-names/'
      path: '/forecast-group-names'
      fullPath: '/backoffice/forecast-group-names'
      preLoaderRoute: typeof AppBackofficeForecastGroupNamesIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/billing/': {
      id: '/_app/backoffice/billing/'
      path: '/billing'
      fullPath: '/backoffice/billing'
      preLoaderRoute: typeof AppBackofficeBillingIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/analytics/': {
      id: '/_app/backoffice/analytics/'
      path: '/analytics'
      fullPath: '/backoffice/analytics'
      preLoaderRoute: typeof AppBackofficeAnalyticsIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/learning/admin/reports': {
      id: '/_app/learning/admin/reports'
      path: '/admin/reports'
      fullPath: '/learning/admin/reports'
      preLoaderRoute: typeof AppLearningAdminReportsRouteImport
      parentRoute: typeof AppLearningRouteRoute
    }
    '/_app/learning/admin/properties': {
      id: '/_app/learning/admin/properties'
      path: '/admin/properties'
      fullPath: '/learning/admin/properties'
      preLoaderRoute: typeof AppLearningAdminPropertiesRouteImport
      parentRoute: typeof AppLearningRouteRoute
    }
    '/_app/learning/admin/new': {
      id: '/_app/learning/admin/new'
      path: '/admin/new'
      fullPath: '/learning/admin/new'
      preLoaderRoute: typeof AppLearningAdminNewRouteImport
      parentRoute: typeof AppLearningRouteRoute
    }
    '/_app/learning/admin/media': {
      id: '/_app/learning/admin/media'
      path: '/admin/media'
      fullPath: '/learning/admin/media'
      preLoaderRoute: typeof AppLearningAdminMediaRouteImport
      parentRoute: typeof AppLearningRouteRoute
    }
    '/_app/learning/admin/$versionId/': {
      id: '/_app/learning/admin/$versionId/'
      path: '/admin/$versionId'
      fullPath: '/learning/admin/$versionId'
      preLoaderRoute: typeof AppLearningAdminVersionIdIndexRouteImport
      parentRoute: typeof AppLearningRouteRoute
    }
    '/_app/backoffice/journey-scheduling/meeting-types/': {
      id: '/_app/backoffice/journey-scheduling/meeting-types/'
      path: '/journey-scheduling/meeting-types'
      fullPath: '/backoffice/journey-scheduling/meeting-types'
      preLoaderRoute: typeof AppBackofficeJourneySchedulingMeetingTypesIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/integrations/zoom/': {
      id: '/_app/backoffice/integrations/zoom/'
      path: '/integrations/zoom'
      fullPath: '/backoffice/integrations/zoom'
      preLoaderRoute: typeof AppBackofficeIntegrationsZoomIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/integrations/stripe/': {
      id: '/_app/backoffice/integrations/stripe/'
      path: '/integrations/stripe'
      fullPath: '/backoffice/integrations/stripe'
      preLoaderRoute: typeof AppBackofficeIntegrationsStripeIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/integrations/slack/': {
      id: '/_app/backoffice/integrations/slack/'
      path: '/integrations/slack'
      fullPath: '/backoffice/integrations/slack'
      preLoaderRoute: typeof AppBackofficeIntegrationsSlackIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/integrations/rules-engine/': {
      id: '/_app/backoffice/integrations/rules-engine/'
      path: '/integrations/rules-engine'
      fullPath: '/backoffice/integrations/rules-engine'
      preLoaderRoute: typeof AppBackofficeIntegrationsRulesEngineIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/integrations/roth-radar/': {
      id: '/_app/backoffice/integrations/roth-radar/'
      path: '/integrations/roth-radar'
      fullPath: '/backoffice/integrations/roth-radar'
      preLoaderRoute: typeof AppBackofficeIntegrationsRothRadarIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/integrations/plaid/': {
      id: '/_app/backoffice/integrations/plaid/'
      path: '/integrations/plaid'
      fullPath: '/backoffice/integrations/plaid'
      preLoaderRoute: typeof AppBackofficeIntegrationsPlaidIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/integrations/mux/': {
      id: '/_app/backoffice/integrations/mux/'
      path: '/integrations/mux'
      fullPath: '/backoffice/integrations/mux'
      preLoaderRoute: typeof AppBackofficeIntegrationsMuxIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/integrations/meeting-transcripts/': {
      id: '/_app/backoffice/integrations/meeting-transcripts/'
      path: '/integrations/meeting-transcripts'
      fullPath: '/backoffice/integrations/meeting-transcripts'
      preLoaderRoute: typeof AppBackofficeIntegrationsMeetingTranscriptsIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/integrations/hubspot/': {
      id: '/_app/backoffice/integrations/hubspot/'
      path: '/integrations/hubspot'
      fullPath: '/backoffice/integrations/hubspot'
      preLoaderRoute: typeof AppBackofficeIntegrationsHubspotIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/integrations/google-drive/': {
      id: '/_app/backoffice/integrations/google-drive/'
      path: '/integrations/google-drive'
      fullPath: '/backoffice/integrations/google-drive'
      preLoaderRoute: typeof AppBackofficeIntegrationsGoogleDriveIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/integrations/front/': {
      id: '/_app/backoffice/integrations/front/'
      path: '/integrations/front'
      fullPath: '/backoffice/integrations/front'
      preLoaderRoute: typeof AppBackofficeIntegrationsFrontIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/analytics/forecasts/': {
      id: '/_app/backoffice/analytics/forecasts/'
      path: '/analytics/forecasts'
      fullPath: '/backoffice/analytics/forecasts'
      preLoaderRoute: typeof AppBackofficeAnalyticsForecastsIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/admin/parity/': {
      id: '/_app/backoffice/admin/parity/'
      path: '/admin/parity'
      fullPath: '/backoffice/admin/parity'
      preLoaderRoute: typeof AppBackofficeAdminParityIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/learning/admin/$versionId/preview': {
      id: '/_app/learning/admin/$versionId/preview'
      path: '/admin/$versionId/preview'
      fullPath: '/learning/admin/$versionId/preview'
      preLoaderRoute: typeof AppLearningAdminVersionIdPreviewRouteImport
      parentRoute: typeof AppLearningRouteRoute
    }
    '/_app/learning/admin/$versionId/assign': {
      id: '/_app/learning/admin/$versionId/assign'
      path: '/admin/$versionId/assign'
      fullPath: '/learning/admin/$versionId/assign'
      preLoaderRoute: typeof AppLearningAdminVersionIdAssignRouteImport
      parentRoute: typeof AppLearningRouteRoute
    }
    '/_app/learning/$courseSlug/lesson/$lessonId': {
      id: '/_app/learning/$courseSlug/lesson/$lessonId'
      path: '/$courseSlug/lesson/$lessonId'
      fullPath: '/learning/$courseSlug/lesson/$lessonId'
      preLoaderRoute: typeof AppLearningCourseSlugLessonLessonIdRouteImport
      parentRoute: typeof AppLearningRouteRoute
    }
    '/_app/clients/$clientId/portal/impersonate': {
      id: '/_app/clients/$clientId/portal/impersonate'
      path: '/clients/$clientId/portal/impersonate'
      fullPath: '/clients/$clientId/portal/impersonate'
      preLoaderRoute: typeof AppClientsClientIdPortalImpersonateRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/backoffice/analytics/users/$userId/': {
      id: '/_app/backoffice/analytics/users/$userId/'
      path: '/analytics/users/$userId'
      fullPath: '/backoffice/analytics/users/$userId'
      preLoaderRoute: typeof AppBackofficeAnalyticsUsersUserIdIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
    '/_app/backoffice/admin/parity/$forecastId/': {
      id: '/_app/backoffice/admin/parity/$forecastId/'
      path: '/admin/parity/$forecastId'
      fullPath: '/backoffice/admin/parity/$forecastId'
      preLoaderRoute: typeof AppBackofficeAdminParityForecastIdIndexRouteImport
      parentRoute: typeof AppBackofficeRouteRoute
    }
  }
}

interface AppBackofficeRouteRouteChildren {
  AppBackofficeIndexRoute: typeof AppBackofficeIndexRoute
  AppBackofficeAnalyticsIndexRoute: typeof AppBackofficeAnalyticsIndexRoute
  AppBackofficeBillingIndexRoute: typeof AppBackofficeBillingIndexRoute
  AppBackofficeForecastGroupNamesIndexRoute: typeof AppBackofficeForecastGroupNamesIndexRoute
  AppBackofficeIntegrationsIndexRoute: typeof AppBackofficeIntegrationsIndexRoute
  AppBackofficeJourneySchedulingIndexRoute: typeof AppBackofficeJourneySchedulingIndexRoute
  AppBackofficeLabelsIndexRoute: typeof AppBackofficeLabelsIndexRoute
  AppBackofficeTermsIndexRoute: typeof AppBackofficeTermsIndexRoute
  AppBackofficeUsersIndexRoute: typeof AppBackofficeUsersIndexRoute
  AppBackofficeAdminParityIndexRoute: typeof AppBackofficeAdminParityIndexRoute
  AppBackofficeAnalyticsForecastsIndexRoute: typeof AppBackofficeAnalyticsForecastsIndexRoute
  AppBackofficeIntegrationsFrontIndexRoute: typeof AppBackofficeIntegrationsFrontIndexRoute
  AppBackofficeIntegrationsGoogleDriveIndexRoute: typeof AppBackofficeIntegrationsGoogleDriveIndexRoute
  AppBackofficeIntegrationsHubspotIndexRoute: typeof AppBackofficeIntegrationsHubspotIndexRoute
  AppBackofficeIntegrationsMeetingTranscriptsIndexRoute: typeof AppBackofficeIntegrationsMeetingTranscriptsIndexRoute
  AppBackofficeIntegrationsMuxIndexRoute: typeof AppBackofficeIntegrationsMuxIndexRoute
  AppBackofficeIntegrationsPlaidIndexRoute: typeof AppBackofficeIntegrationsPlaidIndexRoute
  AppBackofficeIntegrationsRothRadarIndexRoute: typeof AppBackofficeIntegrationsRothRadarIndexRoute
  AppBackofficeIntegrationsRulesEngineIndexRoute: typeof AppBackofficeIntegrationsRulesEngineIndexRoute
  AppBackofficeIntegrationsSlackIndexRoute: typeof AppBackofficeIntegrationsSlackIndexRoute
  AppBackofficeIntegrationsStripeIndexRoute: typeof AppBackofficeIntegrationsStripeIndexRoute
  AppBackofficeIntegrationsZoomIndexRoute: typeof AppBackofficeIntegrationsZoomIndexRoute
  AppBackofficeJourneySchedulingMeetingTypesIndexRoute: typeof AppBackofficeJourneySchedulingMeetingTypesIndexRoute
  AppBackofficeAdminParityForecastIdIndexRoute: typeof AppBackofficeAdminParityForecastIdIndexRoute
  AppBackofficeAnalyticsUsersUserIdIndexRoute: typeof AppBackofficeAnalyticsUsersUserIdIndexRoute
}

const AppBackofficeRouteRouteChildren: AppBackofficeRouteRouteChildren = {
  AppBackofficeIndexRoute: AppBackofficeIndexRoute,
  AppBackofficeAnalyticsIndexRoute: AppBackofficeAnalyticsIndexRoute,
  AppBackofficeBillingIndexRoute: AppBackofficeBillingIndexRoute,
  AppBackofficeForecastGroupNamesIndexRoute:
    AppBackofficeForecastGroupNamesIndexRoute,
  AppBackofficeIntegrationsIndexRoute: AppBackofficeIntegrationsIndexRoute,
  AppBackofficeJourneySchedulingIndexRoute:
    AppBackofficeJourneySchedulingIndexRoute,
  AppBackofficeLabelsIndexRoute: AppBackofficeLabelsIndexRoute,
  AppBackofficeTermsIndexRoute: AppBackofficeTermsIndexRoute,
  AppBackofficeUsersIndexRoute: AppBackofficeUsersIndexRoute,
  AppBackofficeAdminParityIndexRoute: AppBackofficeAdminParityIndexRoute,
  AppBackofficeAnalyticsForecastsIndexRoute:
    AppBackofficeAnalyticsForecastsIndexRoute,
  AppBackofficeIntegrationsFrontIndexRoute:
    AppBackofficeIntegrationsFrontIndexRoute,
  AppBackofficeIntegrationsGoogleDriveIndexRoute:
    AppBackofficeIntegrationsGoogleDriveIndexRoute,
  AppBackofficeIntegrationsHubspotIndexRoute:
    AppBackofficeIntegrationsHubspotIndexRoute,
  AppBackofficeIntegrationsMeetingTranscriptsIndexRoute:
    AppBackofficeIntegrationsMeetingTranscriptsIndexRoute,
  AppBackofficeIntegrationsMuxIndexRoute:
    AppBackofficeIntegrationsMuxIndexRoute,
  AppBackofficeIntegrationsPlaidIndexRoute:
    AppBackofficeIntegrationsPlaidIndexRoute,
  AppBackofficeIntegrationsRothRadarIndexRoute:
    AppBackofficeIntegrationsRothRadarIndexRoute,
  AppBackofficeIntegrationsRulesEngineIndexRoute:
    AppBackofficeIntegrationsRulesEngineIndexRoute,
  AppBackofficeIntegrationsSlackIndexRoute:
    AppBackofficeIntegrationsSlackIndexRoute,
  AppBackofficeIntegrationsStripeIndexRoute:
    AppBackofficeIntegrationsStripeIndexRoute,
  AppBackofficeIntegrationsZoomIndexRoute:
    AppBackofficeIntegrationsZoomIndexRoute,
  AppBackofficeJourneySchedulingMeetingTypesIndexRoute:
    AppBackofficeJourneySchedulingMeetingTypesIndexRoute,
  AppBackofficeAdminParityForecastIdIndexRoute:
    AppBackofficeAdminParityForecastIdIndexRoute,
  AppBackofficeAnalyticsUsersUserIdIndexRoute:
    AppBackofficeAnalyticsUsersUserIdIndexRoute,
}

const AppBackofficeRouteRouteWithChildren =
  AppBackofficeRouteRoute._addFileChildren(AppBackofficeRouteRouteChildren)

interface AppLearningRouteRouteChildren {
  AppLearningBrowseRoute: typeof AppLearningBrowseRoute
  AppLearningIndexRoute: typeof AppLearningIndexRoute
  AppLearningAdminMediaRoute: typeof AppLearningAdminMediaRoute
  AppLearningAdminNewRoute: typeof AppLearningAdminNewRoute
  AppLearningAdminPropertiesRoute: typeof AppLearningAdminPropertiesRoute
  AppLearningAdminReportsRoute: typeof AppLearningAdminReportsRoute
  AppLearningCourseSlugIndexRoute: typeof AppLearningCourseSlugIndexRoute
  AppLearningAdminIndexRoute: typeof AppLearningAdminIndexRoute
  AppLearningCourseSlugLessonLessonIdRoute: typeof AppLearningCourseSlugLessonLessonIdRoute
  AppLearningAdminVersionIdAssignRoute: typeof AppLearningAdminVersionIdAssignRoute
  AppLearningAdminVersionIdPreviewRoute: typeof AppLearningAdminVersionIdPreviewRoute
  AppLearningAdminVersionIdIndexRoute: typeof AppLearningAdminVersionIdIndexRoute
}

const AppLearningRouteRouteChildren: AppLearningRouteRouteChildren = {
  AppLearningBrowseRoute: AppLearningBrowseRoute,
  AppLearningIndexRoute: AppLearningIndexRoute,
  AppLearningAdminMediaRoute: AppLearningAdminMediaRoute,
  AppLearningAdminNewRoute: AppLearningAdminNewRoute,
  AppLearningAdminPropertiesRoute: AppLearningAdminPropertiesRoute,
  AppLearningAdminReportsRoute: AppLearningAdminReportsRoute,
  AppLearningCourseSlugIndexRoute: AppLearningCourseSlugIndexRoute,
  AppLearningAdminIndexRoute: AppLearningAdminIndexRoute,
  AppLearningCourseSlugLessonLessonIdRoute:
    AppLearningCourseSlugLessonLessonIdRoute,
  AppLearningAdminVersionIdAssignRoute: AppLearningAdminVersionIdAssignRoute,
  AppLearningAdminVersionIdPreviewRoute: AppLearningAdminVersionIdPreviewRoute,
  AppLearningAdminVersionIdIndexRoute: AppLearningAdminVersionIdIndexRoute,
}

const AppLearningRouteRouteWithChildren =
  AppLearningRouteRoute._addFileChildren(AppLearningRouteRouteChildren)

interface AppRouteRouteChildren {
  AppBackofficeRouteRoute: typeof AppBackofficeRouteRouteWithChildren
  AppLearningRouteRoute: typeof AppLearningRouteRouteWithChildren
  AppAnnualReviewStartRoute: typeof AppAnnualReviewStartRoute
  AppClientsIndexRoute: typeof AppClientsIndexRoute
  AppHomeIndexRoute: typeof AppHomeIndexRoute
  AppIrsTablesIndexRoute: typeof AppIrsTablesIndexRoute
  AppProfileIndexRoute: typeof AppProfileIndexRoute
  AppRecommendedFilesIndexRoute: typeof AppRecommendedFilesIndexRoute
  AppSharefileMigrationIndexRoute: typeof AppSharefileMigrationIndexRoute
  AppToolsIndexRoute: typeof AppToolsIndexRoute
  AppClientsClientIdIndexRoute: typeof AppClientsClientIdIndexRoute
  AppToolsRmdCalculatorIndexRoute: typeof AppToolsRmdCalculatorIndexRoute
  AppToolsTaxFactoryIndexRoute: typeof AppToolsTaxFactoryIndexRoute
  AppClientsClientIdPortalImpersonateRoute: typeof AppClientsClientIdPortalImpersonateRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppBackofficeRouteRoute: AppBackofficeRouteRouteWithChildren,
  AppLearningRouteRoute: AppLearningRouteRouteWithChildren,
  AppAnnualReviewStartRoute: AppAnnualReviewStartRoute,
  AppClientsIndexRoute: AppClientsIndexRoute,
  AppHomeIndexRoute: AppHomeIndexRoute,
  AppIrsTablesIndexRoute: AppIrsTablesIndexRoute,
  AppProfileIndexRoute: AppProfileIndexRoute,
  AppRecommendedFilesIndexRoute: AppRecommendedFilesIndexRoute,
  AppSharefileMigrationIndexRoute: AppSharefileMigrationIndexRoute,
  AppToolsIndexRoute: AppToolsIndexRoute,
  AppClientsClientIdIndexRoute: AppClientsClientIdIndexRoute,
  AppToolsRmdCalculatorIndexRoute: AppToolsRmdCalculatorIndexRoute,
  AppToolsTaxFactoryIndexRoute: AppToolsTaxFactoryIndexRoute,
  AppClientsClientIdPortalImpersonateRoute:
    AppClientsClientIdPortalImpersonateRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthLoginIndexRoute: typeof AuthLoginIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthLoginIndexRoute: AuthLoginIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  SplatRoute: SplatRoute,
  RRmdCalculationIdRoute: RRmdCalculationIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
